import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = 'token'

export const login = token => {
  return localStorage.setItem(TOKEN_KEY, token);
};

export const localClear = () => {
  return localStorage.clear();
};

export const setLocal = (name, value) => {
  return localStorage.setItem(name, value);
};

export const getLocal = (name) => {
  return localStorage.getItem(name);
};

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const isGenericaToken = () => {
  if(isAuthenticated()){
    const decoded = jwtDecode(getToken())
    return decoded.providers !== undefined
  } else 
  return false
}


export const isTokenExpired = () => {
  const token = getToken();
  if (!token) {
    return null;
  }

  const decoded = jwtDecode(getToken());

  var tokenExpiry = decoded.exp * 1000;

  return new Date() > tokenExpiry;
};